module.exports = __webpack_public_path__ + "img/h1.541613ef.png";